import { configureStore } from "@reduxjs/toolkit";
import LayoutReducers from "./Reducers/Layout/LayoutReducers";
import ThemeCustomizerReducers from "./Reducers/Layout/ThemeCustomizerReducers";
import LetterBoxSlice from "./Reducers/LetterBoxSlice";
import ProjectSlice from "./Reducers/ProjectSlice";
import FilterSlice from "./Reducers/ECommerce/FilterSlice";
import ProductSlice from "./Reducers/ECommerce/ProductSlice";
import CartSlice from "./Reducers/ECommerce/CartSlice";
import TaskSlice from "./Reducers/TaskSlice";
import BookmarkTabSlice from "./Reducers/BookmarkTabSlice";
import ContactReducer from "./Reducers/ContactReducer";
import ChatSlice from "./Reducers/ChatSlice";
import ToDoSlice from "./Reducers/ToDoSlice";
import AddProductSlice from "./Reducers/ECommerce/AddProductSlice";
import authReducer from "./Reducers/Layout/AuthReducer";

export const store = configureStore({
  reducer: {
    layout: LayoutReducers,
    themeCustomizer: ThemeCustomizerReducers,
    letterBox: LetterBoxSlice,
    project: ProjectSlice,
    filterData: FilterSlice,
    product: ProductSlice,
    cartData: CartSlice,
    task: TaskSlice,
    bookmarkTab:BookmarkTabSlice,
    contact: ContactReducer,
    chat:ChatSlice,
    todo:ToDoSlice,
    addProduct: AddProductSlice,
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
